export const FinalBannerState = {
  beforeAnnouncement: 'beforeAnnouncement',
  afterUnidentified: 'afterUnidentified',
  afterAdvanced: 'afterAdvanced',
  afterNotAdvanced: 'afterNotAdvanced',
  beforeAnnouncementCharedi: 'beforeAnnouncementCharedi',
  afterUnidentifiedCharedi: 'afterUnidentifiedCharedi',
  afterPublishFinalWinners: 'afterPublishFinalWinners',
  afterPublishFinalWinnersCharedi: 'afterPublishFinalWinnersCharedi',
};
